module.exports = __webpack_public_path__ + "static/img/serverSwiperTwo.91ed4be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serverSwiperTwo.png
// module id = /yVl
// module chunks = 1